import React from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import { ButtonPrimary } from '@spotify-internal/encore-web';
import { css } from 'emotion';

const CancelUploadConfirmationModal = ({
  hideConfirmationModal,
  onCancel,
  cancelUploadStatus,
}: {
  hideConfirmationModal: () => void;
  onCancel: () => void;
  cancelUploadStatus: string;
}) => (
  <Modal
    isShowing
    isShowingCloseButton
    onClose={hideConfirmationModal}
    aria-labelledby="cancel-upload-confirmation-title"
    size="small"
  >
    <Modal.Title id="cancel-upload-confirmation-title">
      Cancel this upload?
    </Modal.Title>
    {cancelUploadStatus === 'error' && (
      <Modal.Error>Something went wrong. Please try again.</Modal.Error>
    )}
    <Modal.Footer>
      <ButtonPrimary
        colorSet="negative"
        className={css`
          color: #ffffff !important;
        `}
        onClick={onCancel}
        disabled={cancelUploadStatus === 'loading'}
      >
        Cancel upload
      </ButtonPrimary>
    </Modal.Footer>
    {/* TODO: Add error messaging */}
  </Modal>
);

export { CancelUploadConfirmationModal };
